$ = require 'jquery'
Keyboard = require 'lib/keyboard'
Keys = require 'data/keys'
SelectMemberOnCardView = require 'views/member/select-member-on-card-view'
Util = require 'lib/util'
View = require 'view'
_ = require 'underscore'
templates = require 'views/internal/templates'
track = require 'debug/track'
l = require 'lib/localize'

module.exports = class ComposerMemberSelectorView extends View
  viewTitleKey: 'select members'

  events:
    'mouseenter .item': 'hoverMemberSelect'
    'click .item': 'addOrRemoveMember'
    'keyup': 'keyupEvent'

  populate: (idMems, hideSearch) ->
    @data =
    {
      idMems: idMems ? _.pluck(@model.getBoard().memberList.filterDeactivated(force: true).models, 'id')
    }

    @data.showSearch = !(@data.idMems.length <= 5 || hideSearch)

  render: ->
    view = @

    @$el.html(
      templates.fill(
        'popover_member_searcher',
        @data
      )
    )

    @fillMems(@data.idMems)
    if @$('.js-filter-emoji').length > 0
      @setTimeout =>
        @$('.js-filter-emoji').focus().select()
      ,  20
    if @$('.js-filter-members').length > 0
      @setTimeout =>
        @$('.js-filter-members').focus().select()
      , 20

    @


  fillMems: (idMems) ->
    $list = @$('.js-members-list')

    $list.empty()

    for idMember in idMems.slice(0, 5)
      member = @modelCache.get('Member', idMember)

      @appendSubview(@subview(SelectMemberOnCardView, member, card: @model), $list)

    return


  filterAndFillMembers: (term) ->
    idBoardMems = _.pluck(@model.getBoard().memberList.models, 'id')
    mems = Util.filterMembers(@modelCache, term, idBoardMems)
    if mems.length > 0
      @fillMems(mems)
      elem = @$('.js-members-list .item:first')
      Util.selectMenuItem(@$('.js-members-list'), '.item', elem)
    else
      @$('.js-members-list').html('<li><p class="empty"></p></li>')
      .find('p').text l('no matched members')

    return


  hoverMemberSelect: (e) ->
    elem = $(e.target).closest('.item')
    Util.selectMenuItem(@$('.js-members-list'), '.item', elem)


  keyupEvent: (e) ->
    key = Keyboard.getKey(e)
    input = $('.js-filter-members').val().trim().toLowerCase()

    if key in [Keys.Tab, Keys.Enter]
      Util.stop(e)
      @$('.js-members-list .item.selected:first .js-select-member').first().click()
      return

    else if key in [Keys.ArrowUp, Keys.ArrowDown]
      Util.stop(e)
      Util.navMenuList(@$('.js-members-list'), '.item', key)
      return

    else
      @filterAndFillMembers(input)
      return


  addOrRemoveMember: (e) ->
    Util.stop(e)
    parent = $(e.target).closest('.item')
    parent.toggleClass('active')
    item = parent.find('.username').text()
    idMember = parent.find('[idMember]').attr('idMember')

    if @model.toggle('idMembers', idMember)
      track('Card Composer', 'Add Member')
    else
      track('Card Composer', 'Remove Member')

    return



// WEBPACK FOOTER //
// ./app/scripts/views/card-composer/composer-member-selector-view.coffee